module.exports = __webpack_public_path__ + "static/media/042-checklist.d0ff93a1.svg";